// Replica of the reference runtime's `style-hover` support (dc-runtime src/pseudo.ts): each distinct
// pseudo-class declaration block becomes one generated class whose declarations are all `!important`,
// so hover styles override inline styles exactly as in the prototype.
import { bidiCss } from './bidi';

let sheet: CSSStyleSheet | null = null;
const cache = new Map<string, string>();
let n = 0;

function importantify(css: string): string {
  const decls: string[] = [];
  let start = 0, depth = 0, quote = '';
  for (let i = 0; i < css.length; i++) {
    const c = css[i];
    if (quote) { if (c === '\\') i++; else if (c === quote) quote = ''; }
    else if (c === '\'' || c === '"') quote = c;
    else if (c === '(') depth++;
    else if (c === ')') depth = Math.max(0, depth - 1);
    else if (c === ';' && depth === 0) { decls.push(css.slice(start, i)); start = i + 1; }
  }
  decls.push(css.slice(start));
  return decls.map(d => d.trim()).filter(Boolean).map(d => /!\s*important$/i.test(d) ? d : d + ' !important').join(';');
}

export function pseudoClass(pseudo: string, css: string, rtl = false): string {
  const k = pseudo + '|' + (rtl ? 'rtl|' : '') + css;
  const hit = cache.get(k);
  if (hit) return hit;
  if (!sheet) {
    const el = document.createElement('style');
    el.setAttribute('data-tp-pseudo', '');
    document.head.appendChild(el);
    sheet = el.sheet;
  }
  const cls = 'scp' + (n++).toString(36);
  sheet!.insertRule('.' + cls + ':' + pseudo + '{' + importantify(rtl ? bidiCss(css) : css) + '}', sheet!.cssRules.length);
  cache.set(k, cls);
  return cls;
}
